import React, { useState, useEffect } from 'react';
import Collapse from 'antd/lib/collapse';
import { technicalQuestions, agreementQuestions } from '../../questions';

import './HelpTab.less';

export const HelpTab = (props) => {
  const { content, theme } = props;
  const { Panel } = Collapse;

  const [title, setTitle] = useState([]);
  const [listOfQuestions, setListOfQuestions] = useState([]);

  const getQuestions = () => {
    if (content === 'technical') {
      setTitle('Technical FAQ');
      setListOfQuestions(technicalQuestions);
    } else if (content === 'agreement') {
      setTitle('Parity Agreement FAQ');
      setListOfQuestions(agreementQuestions);
    }
  };

  useEffect(() => {
    getQuestions();
  }, []);

  return (
    <div className={`help-tab-content help-tab-content-${theme}`}>
      <div className="help-tab-title">{title}</div>
      <Collapse expandIconPosition="right" className="help-questions-list">
        {listOfQuestions.map((singleQuestion) => {
          const { question, answer, id } = singleQuestion;

          return (
            <Panel header={question} key={id} className="help-question-title">
              <div>{answer}</div>
            </Panel>
          );
        })}
      </Collapse>
    </div>
  );
};
